var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app position-relative h-100"},[(_vm.checkingLogin)?_c('loading-overlay'):_c('div',[(!_vm.HideNavigation)?_c('navigation-custom',{staticClass:"sticky top-0 z-50"}):_vm._e(),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }